export default __webpack_public_path__ + "static/media/Ellipse 16.99f1d735.svg";